const EVENT_ACCOUNT_CANCELLATION = 'account_cancellation'
const EVENT_ACCOUNT_CREATION = 'account_creation'
const EVENT_ACCOUNT_UPDATE = 'account_update'
const EVENT_CONTENT_ACCESS = 'content_access'
const EVENT_ECOMM_ADD_INGREDIENT = 'perso_add_ingredient'
const EVENT_ECOMM_CARD_REGISTRATION = 'enregistrement_cb'
const EVENT_ECOMM_CATALOG_FILTER = 'perso_product_filter'
const EVENT_ECOMM_COLLECT_MODE = 'collect_mode'
const EVENT_ECOMM_ORDER_VALIDATED = 'order_validated'
const EVENT_ECOMM_REMOVE_INGREDIENT = 'perso_remove_ingredient'
const EVENT_ECOMM_SELECT_PROMOTION = 'select_promotion'
const EVENT_ECOMM_UPSELL = 'perso_upsell'
const EVENT_COMMAND_CANCELLATION = 'command_cancellation'
const EVENT_COMMAND_REUSE = 'command_reuse'
const EVENT_KINGDOM_REWARD_CHOSEN = 'decision_royale'
const EVENT_SIGNIN = 'Connexion a Kingdom'
const EVENT_USER_NAVIGATION = 'navigation'

const EVENT_CATEGORY_CLICK_AND_COLLECT = 'Click & Collect'
const EVENT_CATEGORY_FAMILY = 'Famille'
const EVENT_CATEGORY_FAQ = 'FAQ'
const EVENT_CATEGORY_FOOTER = 'Pied de page'
const EVENT_CATEGORY_FRANCHISE = 'Franchise'
const EVENT_CATEGORY_HEADER = 'En-tête'
const EVENT_CATEGORY_HOME = 'Accueil'
const EVENT_CATEGORY_KINGDOM = 'Kingdom'
const EVENT_CATEGORY_MENU = 'Menu'
const EVENT_CATEGORY_PRODUCT = 'Produit'
const EVENT_CATEGORY_STORE_LOCATOR = 'Trouver un restaurant'
const EVENT_CATEGORY_TIMELINE = 'Timeline'
const EVENT_CATEGORY_DELIVERY = 'Livraison'
const EVENT_CATEGORY_ECOMM_DELIVERY = 'Delivery'

const EVENT_ACTION_ECOMM_ADD_INGREDIENT = 'Ajout ingrédient'
const EVENT_ACTION_ECOMM_ALLERGENS_SELECTED = 'Filtre allergene'
const EVENT_ACTION_ECOMM_CARD_REGISTRATION = 'Enregistrement carte bancaire'
const EVENT_ACTION_ECOMM_CATALOG_FILTER = 'Filtre produit'
const EVENT_ACTION_ECOMM_COLLECT_MODE = 'Mode de collect Click & Collect'
const EVENT_ACTION_ECOMM_COUPON = 'Coupon'
const EVENT_ACTION_ECOMM_DELIVERY = 'Mode de collect Livraison domicile'
const EVENT_ACTION_ECOMM_ORDER_VALIDATED = 'Order Validated'
const EVENT_ACTION_ECOMM_REMOVE_INGREDIENT = 'Retirer ingrédient'
const EVENT_ACTION_ECOMM_RESTAURANT_SET = 'Choix restaurant'
const EVENT_ACTION_ECOMM_UPSELL = 'Upsell produit'
const EVENT_ACTION_FAMILY = 'Coin Famille'
const EVENT_ACTION_FORM = 'Formulaire'
const EVENT_ACTION_INFOS = 'Informations'
const EVENT_ACTION_KINGDOM_ADD_COUPON_ERROR = 'Code promo invalide'
const EVENT_ACTION_KINGDOM_ADD_COUPON_SUCCESS = 'Code promo'
const EVENT_ACTION_KINGDOM_CARD_UPDATE = 'Activer la carte Kingdom'
const EVENT_ACTION_KINGDOM_CHALLENGES_SELECTED_BLAZONS = 'Blasons'
const EVENT_ACTION_KINGDOM_CROWN_TRANSFORM = 'Convertir mes couronnes'
const EVENT_ACTION_KINGDOM_DELETE = 'Suppression de compte'
const EVENT_ACTION_KINGDOM_PRIVILEGE_CHALLENGE_BUTTON = 'Mes défis'
const EVENT_ACTION_KINGDOM_PROFILE_SAVE =
    'Enregistrer les informations personnelles'
const EVENT_ACTION_KINGDOM_RESTAURANTS = 'Restaurants'
const EVENT_ACTION_KINGDOM_REWARD_CHOSEN = 'Décision royale'
const EVENT_ACTION_SIGNIN = 'Connexion a Kingdom'
const EVENT_ACTION_SIGNUP = 'Creation de compte'

const EVENT_LABEL_FAMILY = 'Page Famille'
const EVENT_LABEL_KINGDOM_DELETE = 'Suppression de compte'
const EVENT_LABEL_KINGDOM_PROFILE_SAVE =
    'Enregistrement des données personnelles'
const EVENT_LABEL_KINGDOM_PRIVILEGE_CHALLENGE_BUTTON = 'Mes défis'

const eventValueNonInteraction = {
    event_value: '',
    event_non_interaction: ''
}

const eventsDefinitions = {
    /* #### HEADER #### */
    LOGO: {
        event_category: EVENT_CATEGORY_HEADER,
        event_action: 'Logo',
        event_label: 'Accueil',
        ...eventValueNonInteraction
    },
    CARTE: {
        event_category: EVENT_CATEGORY_HEADER,
        event_action: 'Notre carte',
        event_label: 'Page Carte',
        ...eventValueNonInteraction
    },
    FAMILY: {
        event_category: EVENT_CATEGORY_HEADER,
        event_action: EVENT_ACTION_FAMILY,
        event_label: EVENT_LABEL_FAMILY,
        ...eventValueNonInteraction
    },
    OFFER: {
        event_category: EVENT_CATEGORY_HEADER,
        event_action: 'Offre',
        event_label: '',
        ...eventValueNonInteraction
    },
    ACCOUNT: undefined,
    BURGER_MENU_OPEN: {
        event_category: EVENT_CATEGORY_HEADER,
        event_action: 'Menu',
        event_label: 'Ouvrir',
        ...eventValueNonInteraction
    },
    BURGER_MENU_CLOSE: {
        event_category: EVENT_CATEGORY_HEADER,
        event_action: 'Fermer',
        event_label: 'Fermer',
        ...eventValueNonInteraction
    },
    /* #### FOOTER #### */
    NEWSLETTER: {
        event_category: EVENT_CATEGORY_FOOTER,
        event_action: 'Newsletter',
        event_label: 'Oui',
        ...eventValueNonInteraction
    },
    SOCIAL: {
        event_category: EVENT_CATEGORY_FOOTER,
        event_action: 'Social',
        event_label: '',
        ...eventValueNonInteraction
    },
    FOOTER_LINK: {
        event_category: EVENT_CATEGORY_FOOTER,
        event_action: '',
        event_label: '',
        ...eventValueNonInteraction
    },
    /* #### MENU #### */
    MENU_OFFER: {
        event_category: EVENT_CATEGORY_MENU,
        event_action: 'Offre',
        event_label: '',
        ...eventValueNonInteraction
    },
    MENU_JOBS: {
        event_category: EVENT_CATEGORY_MENU,
        event_action: 'Nous rejoindre',
        event_label: 'Page RH',
        ...eventValueNonInteraction
    },
    MENU_FRANCHISE: {
        event_category: EVENT_CATEGORY_MENU,
        event_action: 'Devenir franchisé',
        event_label: 'Page Franchise',
        ...eventValueNonInteraction
    },
    MENU_TIMELINE: {
        event_category: EVENT_CATEGORY_MENU,
        event_action: 'Notre histoire',
        event_label: 'Page Timeline',
        ...eventValueNonInteraction
    },
    MENU_FAQ: {
        event_category: EVENT_CATEGORY_MENU,
        event_action: 'Nous contacter',
        event_label: 'Page Contact',
        ...eventValueNonInteraction
    },
    MENU_CARTE: {
        event_category: EVENT_CATEGORY_MENU,
        event_action: 'Notre carte',
        event_label: 'Page Carte',
        ...eventValueNonInteraction
    },
    MENU_FAMILY: {
        event_category: EVENT_CATEGORY_MENU,
        event_action: EVENT_ACTION_FAMILY,
        event_label: EVENT_LABEL_FAMILY,
        ...eventValueNonInteraction
    },
    /* #### PRODUIT #### */
    ALLERGEN: {
        event_category: EVENT_CATEGORY_PRODUCT,
        event_action: 'Allergènes',
        event_label: EVENT_ACTION_INFOS,
        ...eventValueNonInteraction
    },
    NUTRITION: {
        event_category: EVENT_CATEGORY_PRODUCT,
        event_action: 'Valeurs Nutritionnelles',
        event_label: EVENT_ACTION_INFOS,
        ...eventValueNonInteraction
    },
    RESTAURANT_SEARCH_PRODUCT: {
        event_category: EVENT_CATEGORY_PRODUCT,
        event_action: 'Restaurant - Recherche',
        event_label: 'Page Restaurants',
        ...eventValueNonInteraction
    },
    /* #### HOME #### */
    RESTAURANT_SEARCH_HOME: {
        event_category: EVENT_CATEGORY_HOME,
        event_action: 'Restaurant',
        event_label: 'Trouver un restaurant',
        ...eventValueNonInteraction
    },
    PRIMARY: {
        event_category: 'Slider',
        event_action: '',
        event_label: '',
        ...eventValueNonInteraction
    },
    /* #### STORE LOCATOR #### */
    RESTAURANT_SHEET: {
        event_category: EVENT_CATEGORY_STORE_LOCATOR,
        event_action: 'Restaurant - Fiche',
        event_label: '',
        ...eventValueNonInteraction
    },
    RESTAURANT_DIRECTIONS: {
        event_category: EVENT_CATEGORY_STORE_LOCATOR,
        event_action: 'Restaurant - Itinéraire',
        event_label: '',
        ...eventValueNonInteraction
    },
    RESTAURANT_SEARCH: {
        event_category: EVENT_CATEGORY_STORE_LOCATOR,
        event_action: 'Restaurant - Recherche',
        event_label: '',
        ...eventValueNonInteraction
    },
    RESTAURANT_GEOLOC: {
        event_category: EVENT_CATEGORY_STORE_LOCATOR,
        event_action: 'Restaurant - Géolocalisation',
        event_label: '',
        ...eventValueNonInteraction
    },
    RESTAURANT_SELECT: {
        event_category: EVENT_CATEGORY_STORE_LOCATOR,
        event_action: 'Restaurant - Informations',
        event_label: '',
        ...eventValueNonInteraction
    },
    RESTAURANT_SERVICES: {
        event_category: EVENT_CATEGORY_STORE_LOCATOR,
        event_action: 'Filtre',
        event_label: '',
        ...eventValueNonInteraction
    },
    /* #### FAMILY #### */
    FAMILY_ANNIVERSARY: {
        event_category: EVENT_CATEGORY_FAMILY,
        event_action: 'Restaurant - Anniversaire',
        event_label: 'Page Restaurants',
        ...eventValueNonInteraction
    },
    /* #### CARTE #### */
    CATEGORY_PRODUCT_CLICK: {
        event_category: 'Carte - ',
        event_action: '',
        event_label: 'Page Produit',
        ...eventValueNonInteraction
    },
    CATEGORY_CLICK: {
        event_category: 'Carte',
        event_action: '',
        event_label: 'carte',
        ...eventValueNonInteraction
    },
    CATEGORY_MENU_CLICK: {
        event_category: 'Carte - ',
        event_action: '',
        event_label: 'category_menu_click',
        ...eventValueNonInteraction
    },
    CATEGORY_FILTER: {
        event_category: '',
        event_action: 'Filtre',
        event_label: '',
        ...eventValueNonInteraction
    },
    CATEGORY_ALLERGEN_FILTER: {
        event_category: 'Carte - ',
        event_action: 'Filtre',
        event_label: '',
        ...eventValueNonInteraction
    },
    /* #### Service conso #### */
    FAQ_FILTER: {
        event_category: EVENT_CATEGORY_FAQ,
        event_action: 'Filtre',
        event_label: '',
        ...eventValueNonInteraction
    },
    FAQ_QUESTIONS: {
        event_category: EVENT_CATEGORY_FAQ,
        event_action: 'Questions',
        event_label: '',
        ...eventValueNonInteraction
    },
    FAQ_QUESTIONS_MORE: {
        event_category: EVENT_CATEGORY_FAQ,
        event_action: 'Questions',
        event_label: 'Voir plus',
        ...eventValueNonInteraction
    },
    FAQ_FORM_CATEGORY: {
        event_category: EVENT_CATEGORY_FAQ,
        event_action: 'Formulaire - Catégorie',
        event_label: '',
        ...eventValueNonInteraction
    },
    FAQ_FORM_SEND: {
        event_category: EVENT_CATEGORY_FAQ,
        event_action: EVENT_ACTION_FORM,
        event_label: 'Envoyer',
        ...eventValueNonInteraction
    },
    FAQ_FORM_RANKING: {
        event_category: EVENT_CATEGORY_FAQ,
        event_action: EVENT_ACTION_FORM,
        ...eventValueNonInteraction
    },
    FAQ_FORM_DPT: {
        event_category: EVENT_CATEGORY_FAQ,
        event_action: EVENT_ACTION_FORM,
        ...eventValueNonInteraction
    },
    FAQ_FORM_RESTAURANT: {
        event_category: EVENT_CATEGORY_FAQ,
        event_action: EVENT_ACTION_FORM,
        ...eventValueNonInteraction
    },
    FAQ_FORM_PAYMENT: {
        event_category: EVENT_CATEGORY_FAQ,
        event_action: EVENT_ACTION_FORM,
        ...eventValueNonInteraction
    },
    FAQ_FORM_ORDER: {
        event_category: EVENT_CATEGORY_FAQ,
        event_action: EVENT_ACTION_FORM,
        ...eventValueNonInteraction
    },
    FAQ_FORM_RECEIPT: {
        event_category: EVENT_CATEGORY_FAQ,
        event_action: EVENT_ACTION_FORM,
        ...eventValueNonInteraction
    },
    /* #### Timeline #### */
    TIMELINE_DISCOVER: {
        event_category: EVENT_CATEGORY_TIMELINE,
        event_action: 'Présentation',
        event_label: 'Découvrir',
        ...eventValueNonInteraction
    },
    TIMELINE_PREV: {
        event_category: EVENT_CATEGORY_TIMELINE,
        event_action: '',
        event_label: 'Précédent',
        ...eventValueNonInteraction
    },
    TIMELINE_NEXT: {
        event_category: EVENT_CATEGORY_TIMELINE,
        event_action: '',
        event_label: 'Suivant',
        ...eventValueNonInteraction
    },
    /* #### Franchise #### */
    FRANCHISE_TESTIMONY_OPEN: {
        event_category: EVENT_CATEGORY_FRANCHISE,
        event_action: 'Témoignage',
        event_label: '',
        ...eventValueNonInteraction
    },
    FRANCHISE_TESTIMONY_CLOSE: {
        event_category: EVENT_CATEGORY_FRANCHISE,
        event_action: 'Témoignage',
        event_label: 'Fermer',
        ...eventValueNonInteraction
    },
    FRANCHISE_MORE: {
        event_category: EVENT_CATEGORY_FRANCHISE,
        event_action: EVENT_ACTION_INFOS,
        event_label: 'En savoir plus',
        ...eventValueNonInteraction
    },
    FRANCHISE_PROFILE_SHEET: {
        event_category: EVENT_CATEGORY_FRANCHISE,
        event_action: EVENT_ACTION_INFOS,
        event_label: 'Fiche Profil',
        ...eventValueNonInteraction
    },
    FRANCHISE_FOLDER: {
        event_category: EVENT_CATEGORY_FRANCHISE,
        event_action: EVENT_ACTION_INFOS,
        event_label: 'Télécharger un dossier',
        ...eventValueNonInteraction
    },
    /* #### KINGDOM #### */
    KINGDOM_ADD_COUPON_ERROR: {
        event_category: EVENT_CATEGORY_KINGDOM,
        event_action: EVENT_ACTION_KINGDOM_ADD_COUPON_ERROR,
        event_label: '',
        ...eventValueNonInteraction
    },
    KINGDOM_ADD_COUPON_SUCCESS: {
        event_category: EVENT_CATEGORY_KINGDOM,
        event_action: EVENT_ACTION_KINGDOM_ADD_COUPON_SUCCESS,
        event_label: '',
        ...eventValueNonInteraction
    },
    KINGDOM_ADD_RESTAURANT: {
        event_category: EVENT_CATEGORY_KINGDOM,
        event_action: EVENT_ACTION_KINGDOM_RESTAURANTS,
        event_label: '',
        ...eventValueNonInteraction
    },
    KINGDOM_CARD_UPDATE: {
        event_category: EVENT_CATEGORY_KINGDOM,
        event_action: EVENT_ACTION_KINGDOM_CARD_UPDATE,
        event_label: '',
        ...eventValueNonInteraction
    },
    KINGDOM_CHALLENGES_SELECTED_BLAZONS: {
        event_category: EVENT_CATEGORY_KINGDOM,
        event_action: EVENT_ACTION_KINGDOM_CHALLENGES_SELECTED_BLAZONS,
        event_label: '',
        ...eventValueNonInteraction
    },
    KINGDOM_CROWN_TRANSFORM: {
        event_category: EVENT_CATEGORY_KINGDOM,
        event_action: EVENT_ACTION_KINGDOM_CROWN_TRANSFORM,
        event_label: '',
        ...eventValueNonInteraction
    },
    KINGDOM_DELETE: {
        event_category: EVENT_CATEGORY_KINGDOM,
        event_action: EVENT_ACTION_KINGDOM_DELETE,
        event_label: EVENT_LABEL_KINGDOM_DELETE,
        ...eventValueNonInteraction
    },
    KINGDOM_PRIVILEGE_CHALLENGE_BUTTON: {
        event_category: EVENT_CATEGORY_KINGDOM,
        event_action: EVENT_ACTION_KINGDOM_PRIVILEGE_CHALLENGE_BUTTON,
        event_label: EVENT_LABEL_KINGDOM_PRIVILEGE_CHALLENGE_BUTTON,
        ...eventValueNonInteraction
    },
    KINGDOM_PROFILE_SAVE: {
        event_category: EVENT_CATEGORY_KINGDOM,
        event_action: EVENT_ACTION_KINGDOM_PROFILE_SAVE,
        event_label: EVENT_LABEL_KINGDOM_PROFILE_SAVE,
        ...eventValueNonInteraction
    },
    KINGDOM_REWARD_CHOSEN: {
        event_category: EVENT_CATEGORY_KINGDOM,
        event_action: EVENT_ACTION_KINGDOM_REWARD_CHOSEN,
        event_label: '',
        ...eventValueNonInteraction
    },
    KINGDOM_SIGNIN: {
        event_category: EVENT_CATEGORY_KINGDOM,
        event_action: EVENT_ACTION_SIGNIN,
        event_label: '',
        ...eventValueNonInteraction
    },
    KINGDOM_SIGNUP: {
        event_category: EVENT_CATEGORY_KINGDOM,
        event_action: EVENT_ACTION_SIGNUP,
        event_label: '',
        ...eventValueNonInteraction
    },
    /* #### CLICK AND COLLECT #### */
    ECOMM_ADD_INGREDIENT: {
        event_category: EVENT_CATEGORY_CLICK_AND_COLLECT,
        event_action: EVENT_ACTION_ECOMM_ADD_INGREDIENT,
        ...eventValueNonInteraction
    },
    ECOMM_ALLERGENS_SELECTED: {
        event_category: EVENT_CATEGORY_CLICK_AND_COLLECT,
        event_action: EVENT_ACTION_ECOMM_ALLERGENS_SELECTED,
        ...eventValueNonInteraction
    },
    ECOMM_CARD_REGISTRATION: {
        event_category: EVENT_CATEGORY_CLICK_AND_COLLECT,
        event_action: EVENT_ACTION_ECOMM_CARD_REGISTRATION,
        ...eventValueNonInteraction
    },
    ECOMM_CATALOG_FILTER: {
        event_category: EVENT_CATEGORY_CLICK_AND_COLLECT,
        event_action: EVENT_ACTION_ECOMM_CATALOG_FILTER,
        ...eventValueNonInteraction
    },
    ECOMM_COLLECT_MODE: {
        event_category: EVENT_CATEGORY_ECOMM_DELIVERY,
        event_action: EVENT_ACTION_ECOMM_COLLECT_MODE,
        ...eventValueNonInteraction
    },
    ECOMM_COUPON: {
        event_category: EVENT_CATEGORY_CLICK_AND_COLLECT,
        event_action: EVENT_ACTION_ECOMM_COUPON,
        ...eventValueNonInteraction
    },
    ECOMM_DELIVERY: {
        event_category: '',
        event_action: EVENT_ACTION_ECOMM_DELIVERY,
        ...eventValueNonInteraction
    },
    ECOMM_IMPERSONAL_OPERATION_COUPON: {
        event_category: '',
        event_action: EVENT_ACTION_KINGDOM_ADD_COUPON_SUCCESS,
        ...eventValueNonInteraction
    },
    ECOMM_ORDER_VALIDATED: {
        event_category: EVENT_CATEGORY_CLICK_AND_COLLECT,
        event_action: EVENT_ACTION_ECOMM_ORDER_VALIDATED,
        ...eventValueNonInteraction
    },
    ECOMM_REMOVE_INGREDIENT: {
        event_category: EVENT_CATEGORY_CLICK_AND_COLLECT,
        event_action: EVENT_ACTION_ECOMM_REMOVE_INGREDIENT,
        ...eventValueNonInteraction
    },
    ECOMM_RESTAURANT_SET: {
        event_category: EVENT_CATEGORY_ECOMM_DELIVERY,
        event_action: EVENT_ACTION_ECOMM_RESTAURANT_SET,
        ...eventValueNonInteraction
    },
    ECOMM_SIGNIN: {
        event_category: EVENT_CATEGORY_CLICK_AND_COLLECT,
        event_action: EVENT_ACTION_SIGNIN,
        ...eventValueNonInteraction
    },
    ECOMM_UPSELL: {
        event_category: EVENT_CATEGORY_CLICK_AND_COLLECT,
        event_action: EVENT_ACTION_ECOMM_UPSELL,
        ...eventValueNonInteraction
    },
    /* #### OTHERS #### */
    SUGGESTION: {
        event_category: '',
        event_action: 'Suggestion - ',
        event_label: '',
        ...eventValueNonInteraction
    },
    FOOTER_NOTICE: {
        event_category: 'Réassurance',
        event_action: 'Nous contacter',
        event_label: 'Page Contact',
        ...eventValueNonInteraction
    },
    DELIVERY: {
        event_category: EVENT_CATEGORY_DELIVERY,
        event_action: '',
        event_label: 'Je me fais livrer',
        ...eventValueNonInteraction
    },
    /* #### 404 #### */
    ERREUR: {
        event_category: 'Erreur',
        event_action: '',
        event_label: '',
        ...eventValueNonInteraction
    },
    /* #### GA4 #### */
    GA4_ACCOUNT_CANCELLATION: {
        event: EVENT_ACCOUNT_CANCELLATION,
        page_template: 'Kingdom'
    },
    GA4_ACCOUNT_CREATION: {
        event: EVENT_ACCOUNT_CREATION,
        page_template: 'Formulaire'
    },
    GA4_ACCOUNT_UPDATE: {
        event: EVENT_ACCOUNT_UPDATE
    },
    GA4_CONTENT_ACCESS: {
        event: EVENT_CONTENT_ACCESS
    },
    GA4_ECOMM_CARD_REGISTRATION: {
        event: EVENT_ECOMM_CARD_REGISTRATION,
        page_category_level_3: 'Paiement'
    },
    GA4_ECOMM_COLLECT_MODE: {
        event: EVENT_ECOMM_COLLECT_MODE,
        collect_type: EVENT_CATEGORY_CLICK_AND_COLLECT
    },
    GA4_ECOMM_CATALOG_FILTER: {
        event: EVENT_ECOMM_CATALOG_FILTER
    },
    GA4_ECOMM_PROMOTION: {
        event: EVENT_ECOMM_SELECT_PROMOTION
    },
    GA4_ECOMM_ORDER_VALIDATED: {
        event: EVENT_ECOMM_ORDER_VALIDATED
    },
    GA4_ECOMM_ADD_INGREDIENT: {
        event: EVENT_ECOMM_ADD_INGREDIENT
    },
    GA4_ECOMM_REMOVE_INGREDIENT: {
        event: EVENT_ECOMM_REMOVE_INGREDIENT
    },
    GA4_ECOMM_UPSELL: {
        event: EVENT_ECOMM_UPSELL
    },
    GA4_COMMAND_CANCELLATION: {
        event: EVENT_COMMAND_CANCELLATION
    },
    GA4_COMMAND_REUSE: {
        event: EVENT_COMMAND_REUSE
    },
    GA4_KINGDOM_REWARD_CHOSEN: {
        event: EVENT_KINGDOM_REWARD_CHOSEN
    },
    GA4_SIGNIN: {
        event: EVENT_SIGNIN
    },
    GA4_USER_NAVIGATION: {
        event: EVENT_USER_NAVIGATION
    }
}

export { eventsDefinitions }
